(function ($) {
  $.fn.onIntersection = function (options) {
    if (typeof options === 'function') {
      options = { callback: options };
    }

    if (! ('callback' in options) || typeof options.callback !== 'function') {
      throw new Error('$.fn.onIntersection - callback must be a function');
    }

    const settings = $.extend({
      once: true,
      root: null,
      rootMargin: "0px",
      threshold: 0.2,
    }, options);

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          settings.callback(entry);
          if (settings.once) {
            observer.unobserve(entry.target);
          }
        }
      });
    }, settings);

    return this.each(function () {
      observer.observe(this);
    });
  };
}(jQuery));
